var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#A)",
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 18.75a1.874 1.874 0 10.001-3.749 1.874 1.874 0 00-.001 3.749zM46.125 18.75a1.874 1.874 0 10.001-3.749 1.874 1.874 0 00-.001 3.749zM2.44 26.268a1.875 1.875 0 101.586-3.397 1.875 1.875 0 00-1.586 3.397zM43.069 8.387a1.875 1.875 0 103.397 1.586 1.875 1.875 0 00-3.397-1.586zM45.561 26.271a1.875 1.875 0 10-1.583-3.398 1.875 1.875 0 001.583 3.398zM4.931 8.387A1.875 1.875 0 101.533 9.97 1.875 1.875 0 004.93 8.387zM25.875 42.375A1.88 1.88 0 0124 44.25a1.88 1.88 0 01-1.875-1.875 1.875 1.875 0 00-3.75 0C18.375 45.477 20.898 48 24 48s5.625-2.523 5.625-5.625a1.875 1.875 0 00-3.75 0zM24 0C14.695 0 7.125 7.57 7.125 16.875c0 4.819 2.042 9.191 5.401 12.299 1.516 1.403 1.866 2.61 2.008 3.605.385 2.691 2.766 4.721 5.541 4.721h7.842c2.797 0 5.18-2.029 5.543-4.72.133-.985.476-2.184 2.014-3.606 2.492-2.306 4.21-5.248 4.968-8.51a16.75 16.75 0 00.433-3.788C40.875 7.57 33.305 0 24 0zm12.79 19.814a12.998 12.998 0 01-3.862 6.607c-1.865 1.726-2.877 3.587-3.183 5.857-.111.825-.914 1.472-1.827 1.472h-7.842c-.92 0-1.706-.645-1.828-1.501-.325-2.273-1.333-4.124-3.174-5.827-2.707-2.505-4.198-5.895-4.198-9.546C10.875 9.638 16.763 3.75 24 3.75s13.125 5.888 13.125 13.125c0 .994-.113 1.983-.335 2.939z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.424 15.549L24 17.973l-2.424-2.424a1.876 1.876 0 00-2.652 2.652l3.201 3.201v2.973a1.874 1.874 0 103.75 0v-2.973l3.201-3.201a1.876 1.876 0 00-2.652-2.652z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0,
    x2: 48,
    y1: 24.115,
    y2: 24.115,
    "gradient-units": "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d946ef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.e63d59c9f4137a283362c7d95f13e058.svg";
export { ForwardRef as ReactComponent };